import { render, staticRenderFns } from "./PlatformOverview.vue?vue&type=template&id=3c85e257&scoped=true"
import script from "./PlatformOverview.vue?vue&type=script&lang=js"
export * from "./PlatformOverview.vue?vue&type=script&lang=js"
import style0 from "./PlatformOverview.vue?vue&type=style&index=0&id=3c85e257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85e257",
  null
  
)

export default component.exports